import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { painPoints } from '../data/megaPack';
import { useIsMobile } from '../hooks/useMediaQuery';
export function PainPoints() {
  const isMobile = useIsMobile();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream-50 py-10 sm:py-20" aria-labelledby="te-pasa-esto" data-id="element-193" data-mp="2bvfwxqxqmacp">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-194" data-mp="1xwg8aja85vgj">
        <div className="max-w-3xl" data-id="element-195" data-mp="21zuslm574xzs">
          <p className="font-display text-[0.7rem] font-700 uppercase tracking-[0.2em] text-teal-600 sm:text-xs" data-id="element-196" data-mp="220wd0h83qwu6">
            Ellos ya tuvieron resultados, ahora faltas vos!!!
          </p>
          <h2 id="te-pasa-esto" className="mt-2 font-display text-2xl font-800 leading-[1.1] text-teal-900 sm:mt-3 sm:text-4xl" data-id="element-197" data-mp="1szg5qicl3au6">
            Si acompañás a un adulto mayor, esto probablemente te suena familiar
          </h2>
        </div>

        {isMobile ? <ul className="mt-6 divide-y divide-teal-900/10 border-y border-teal-900/10" data-id="element-198" data-mp="1yzdmwlx3abmj">
            {painPoints.map((item, index) => {
          const isOpen = openIndex === index;
          return <li key={item.title} data-id="element-199" data-mp="27s76uwnhdz6q" data-mpi={index}>
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`pain-panel-${index}`} className="flex w-full items-center justify-between gap-3 py-3 text-left" data-id="element-200" data-mp="23rnahvaqezln">
                    <span className="font-display text-sm font-700 leading-snug text-teal-800" data-id="element-201" data-mp="1p3afb0jgxks7">
                      {item.title}
                    </span>
                    <ChevronDownIcon className={['h-4 w-4 shrink-0 text-teal-600 transition-transform duration-200 ease-out', isOpen ? 'rotate-180' : ''].join(' ')} aria-hidden="true" data-id="element-202" data-mp="30he7c16hwyum" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-203" data-mp="1y2orbf90hmrl">
                    {isOpen ? <motion.div id={`pain-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-204" data-mp="2274sj37ok60h">
                        <p className="pb-3 pr-6 text-[0.8rem] leading-relaxed text-clay" data-id="element-205" data-mp="1jd8zdvxqvbab">
                          {item.description}
                        </p>
                      </motion.div> : null}
                  </AnimatePresence>
                </li>;
        })}
          </ul> : <ul className="mt-10 grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-206" data-mp="o6rxklcwry0n">
            {painPoints.map(item => <li key={item.title} className="border-t border-teal-900/12 pt-5" data-id="element-207" data-mp="j86tgaujcu6x">
                <h3 className="font-display text-base font-700 leading-snug text-teal-800" data-id="element-208" data-mp="e7au8al4pw7u">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-clay" data-id="element-209" data-mp="a67fxsiqc88q">
                  {item.description}
                </p>
              </li>)}
          </ul>}

        <p className="mt-8 text-center font-display text-lg font-800 uppercase leading-tight text-teal-900 sm:mt-14 sm:text-3xl" data-id="element-210" data-mp="f306ql8cjcu">
          ¿Cuántos momentos más vas a dejar pasar{' '}
          <span className="text-gold-600" data-id="element-211" data-mp="3mox9zjnqupmv">sin saber qué hacer?</span>
        </p>
      </div>
    </section>;
}